import { Search as SearchSnack } from '@snack-uikit/search';
import { Typography } from '@snack-uikit/typography';
import { useState } from 'react';

import { CardList, Condition } from '@/components/static';
import { MainPageArticleBlock, MainPageConfigData } from '@/types/ssr';
import { curry, evolve, isEmpty, toLowerCase } from '@/utils/common';
import { isExternalLink, toAbsolutePath } from '@/utils/navigation';

import s from './styles.module.scss';

const updateUrl = (url: string) => {
  if (isExternalLink(url)) return url;
  return toAbsolutePath(url);
};

export function MainPageContent({
  config,
  defaultIconName,
}: { config: MainPageConfigData } & { defaultIconName?: string }) {
  const [search, setSearch] = useState('');

  const matchedWithSearch = (article: MainPageArticleBlock) => {
    const loweredTitle = toLowerCase(article.title);
    const loweredDescription = toLowerCase(article.description);
    const loweredSearch = toLowerCase(search);
    return loweredDescription.includes(loweredSearch) || loweredTitle.includes(loweredSearch);
  };

  const filteredBlocks = config.categories?.filter(category => category?.articles?.some(matchedWithSearch)) || [];

  const updateContentBlockStructure = curry(evolve<MainPageArticleBlock>)({
    url: updateUrl,
  });
  const hasSearch = Boolean(config.hasSearch);

  const itemForRender = hasSearch ? filteredBlocks : config.categories || [];

  return (
    <section id={config.anchor} className={s.main_page_content_wrapper}>
      <Typography.SansHeadlineL tag='h3' className={s.article_title}>
        {config.title}
      </Typography.SansHeadlineL>

      <Condition when={Boolean(config.hasSearch)}>
        <SearchSnack outline value={search} onChange={setSearch} placeholder='Поиск по сервисам' size='l' />
      </Condition>

      <Condition
        when={!isEmpty(itemForRender)}
        otherwise={<Typography.SansLabelL> Ничего не найдено </Typography.SansLabelL>}
      >
        {itemForRender.map(({ title = '', anchor, articles }) => {
          const key = title.concat(anchor || '');
          const list = articles?.filter(matchedWithSearch).map(updateContentBlockStructure);
          if (!title) {
            return <CardList key={key} list={list} />;
          }
          return (
            <section className={s.category_wrapper} key={key} id={anchor}>
              <Typography.SansTitleL tag='h3'>{title}</Typography.SansTitleL>
              <CardList defaultIconName={defaultIconName} list={list} />
            </section>
          );
        })}
      </Condition>
    </section>
  );
}
